/* SAVORI theme — tilt, AJAX cart drawer, product page */
(function(){
  "use strict";
  var money = function(cents){
    return "$" + (cents/100).toLocaleString(undefined,{minimumFractionDigits:(cents%100?2:0),maximumFractionDigits:2});
  };
  var toast = (function(){
    var el = document.getElementById("toast"), t;
    return function(msg){ if(!el) return; el.textContent=msg; el.classList.add("show"); clearTimeout(t); t=setTimeout(function(){el.classList.remove("show");},2600); };
  })();

  /* ---------- header dock ---------- */
  var head = document.querySelector(".site-head");
  if(head){ window.addEventListener("scroll", function(){ head.classList.toggle("docked", window.scrollY>60); }); }

  /* ---------- scroll reveal ---------- */
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(en){ if(en.isIntersecting){ en.target.classList.add("in"); io.unobserve(en.target); } });
  }, {threshold:.15});
  document.querySelectorAll(".reveal").forEach(function(el){ io.observe(el); });

  /* ---------- 3D tilt ---------- */
  document.querySelectorAll("[data-tilt]").forEach(function(el){
    var s=6;
    el.addEventListener("mousemove", function(e){
      var r=el.getBoundingClientRect();
      var x=(e.clientX-r.left)/r.width-.5, y=(e.clientY-r.top)/r.height-.5;
      el.style.transform="rotateY("+(x*s)+"deg) rotateX("+(-y*s)+"deg)";
    });
    el.addEventListener("mouseleave", function(){ el.style.transform=""; });
  });

  /* ---------- cart drawer ---------- */
  var cart = document.getElementById("cartDrawer");
  var scrim = document.getElementById("cartScrim");
  var itemsEl = document.getElementById("cartItems");
  var totalEl = document.getElementById("cartTotal");
  var countEls = document.querySelectorAll("[data-cart-count]");

  function setCount(n){ countEls.forEach(function(e){ e.textContent=n; }); }
  function openCart(){ if(!cart) return; cart.classList.add("open"); scrim.classList.add("open"); document.body.classList.add("locked"); }
  function closeCart(){ if(!cart) return; cart.classList.remove("open"); scrim.classList.remove("open"); document.body.classList.remove("locked"); }

  function renderCart(data){
    setCount(data.item_count);
    if(!itemsEl) return;
    if(data.item_count===0){
      itemsEl.innerHTML='<div class="cart-empty">The vault is quiet. Nothing chosen yet.</div>';
      totalEl.textContent="$0"; return;
    }
    var html="";
    data.items.forEach(function(it){
      var img = it.image ? '<img src="'+it.image+'" alt="">' : '<div class="plate-glyph"><div class="ring" style="width:50%"></div></div>';
      var variant = it.variant_title && it.variant_title !== "Default Title" ? it.variant_title : it.product_type;
      html += '<div class="ci">'
        + '<div class="ci-thumb">'+img+'</div>'
        + '<div class="ci-mid"><h4>'+it.product_title+'</h4>'
        + '<div class="ci-size">'+ (variant||"") +'</div>'
        + '<button class="ci-rm" data-key="'+it.key+'">Remove</button></div>'
        + '<div class="ci-price">'+money(it.final_line_price)+'</div></div>';
    });
    itemsEl.innerHTML=html;
    totalEl.textContent=money(data.items_subtotal_price);
    itemsEl.querySelectorAll(".ci-rm").forEach(function(b){
      b.addEventListener("click", function(){ changeItem(b.getAttribute("data-key"), 0); });
    });
  }

  function refreshCart(open){
    fetch("/cart.js",{headers:{"Accept":"application/json"}})
      .then(function(r){return r.json();})
      .then(function(d){ renderCart(d); if(open) openCart(); })
      .catch(function(){});
  }

  function changeItem(key, qty){
    fetch("/cart/change.js",{method:"POST",headers:{"Content-Type":"application/json","Accept":"application/json"},
      body:JSON.stringify({id:key,quantity:qty})})
      .then(function(r){return r.json();})
      .then(function(d){ renderCart(d); })
      .catch(function(){});
  }

  window.savoriAddToCart = function(variantId, label){
    fetch("/cart/add.js",{method:"POST",headers:{"Content-Type":"application/json","Accept":"application/json"},
      body:JSON.stringify({items:[{id:variantId,quantity:1}]})})
      .then(function(r){ if(!r.ok) throw new Error("add"); return r.json(); })
      .then(function(){ toast((label||"Item")+" added to bag"); refreshCart(true); })
      .catch(function(){ toast("Sold out or unavailable"); });
  };

  // open-cart triggers
  document.querySelectorAll("[data-open-cart]").forEach(function(b){
    b.addEventListener("click", function(e){ e.preventDefault(); refreshCart(true); });
  });
  if(scrim) scrim.addEventListener("click", closeCart);
  var cx = document.getElementById("cartClose");
  if(cx) cx.addEventListener("click", closeCart);
  document.addEventListener("keydown", function(e){ if(e.key==="Escape") closeCart(); });

  // initial count
  refreshCart(false);

  /* ---------- product page ---------- */
  var pdp = document.getElementById("pdp");
  if(pdp){
    var chosen=null, addBtn=document.getElementById("pAdd"), basePrice=addBtn.getAttribute("data-price");
    pdp.querySelectorAll(".p-size").forEach(function(b){
      b.addEventListener("click", function(){
        if(b.disabled) return;
        chosen=b.getAttribute("data-variant");
        pdp.querySelectorAll(".p-size").forEach(function(x){x.classList.remove("on");});
        b.classList.add("on");
        addBtn.disabled=false; addBtn.textContent="Add to Bag — "+basePrice;
      });
    });
    addBtn.addEventListener("click", function(){
      if(!chosen) return;
      window.savoriAddToCart(chosen, addBtn.getAttribute("data-title"));
    });
    // gallery thumbs
    var mainImg=document.getElementById("pMain");
    pdp.querySelectorAll(".pdp-thumbs img").forEach(function(t){
      t.addEventListener("click", function(){
        mainImg.src=t.getAttribute("data-full")||t.src;
        pdp.querySelectorAll(".pdp-thumbs img").forEach(function(x){x.classList.remove("on");});
        t.classList.add("on");
      });
    });
  }
})();
